import {CustomerReferenceNavigator} from "@/components/app-hostesses/shared/customer-reference-navigator";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { Toaster } from '@sakura-grp/ui/sonner';
import { AuthProvider } from '@/components/providers/AuthProvider';

// Layouts
import AppLayout from '@/components/layout/AppLayout';
import {ProtectedHostessLayout} from '@/components/layout/ProtectedHostessLayout';

// Routes
import Dashboard from '@/routes/dashboard';
import Reservations from '@/routes/reservations';
import Announcements from '@/routes/announcements';
import CustomerDetail from '@/routes/customer-detail';
import SignIn from '@/routes/sign-in';
import SignOut from '@/routes/sign-out';
import Mypage from '@/routes/mypage';
import Privacy from '@/routes/privacy';
import About from '@/routes/about';

function App() {
  return (
    <>
      <AuthProvider>
        <BrowserRouter>
          <NuqsAdapter>
          <CustomerReferenceNavigator />
          <Routes>
            <Route path="/sign-in" element={<SignIn />} />
            <Route path="/sign-out" element={<SignOut />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/about" element={<About />} />

            <Route path="/" element={<ProtectedHostessLayout />}>
              <Route element={<AppLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="reservations" element={<Reservations />} />
                <Route path="announcements" element={<Announcements />} />
                <Route path="mypage" element={<Mypage />} />

                <Route path="customers">
                  <Route path=":id" element={<CustomerDetail />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Route>
          </Routes>
          </NuqsAdapter>
        </BrowserRouter>
      </AuthProvider>

      <Toaster position="top-center" />
    </>
  );
}

export default App;
